import { RefObject, useEffect, useRef, useState } from 'react';

const TOP_REVEAL_POINT = 24;
const HIDE_AFTER = 72;

export default function useAutoHideOnScroll(scrollArea: RefObject<HTMLElement>) {
  const [hidden, setHidden] = useState(false);
  const previousTop = useRef(0);
  const frame = useRef<number | null>(null);

  useEffect(() => {
    const element = scrollArea.current;
    if (!element) return;

    previousTop.current = element.scrollTop;

    const update = () => {
      const currentTop = element.scrollTop;
      const movement = currentTop - previousTop.current;

      if (currentTop <= TOP_REVEAL_POINT || movement < 0) {
        setHidden(false);
      } else if (currentTop > HIDE_AFTER && movement > 0) {
        setHidden(true);
      }

      previousTop.current = currentTop;
      frame.current = null;
    };

    const onScroll = () => {
      if (frame.current === null) frame.current = window.requestAnimationFrame(update);
    };

    element.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      element.removeEventListener('scroll', onScroll);
      if (frame.current !== null) window.cancelAnimationFrame(frame.current);
    };
  }, [scrollArea]);

  return hidden;
}
